// @flow

import {SORTABLE_POSITION} from '@pb/kit-component-native-sortable';
import {colors} from '@pb/kit-stylus/config.json';

import {headerCellName, tableCellName, tableRowName} from '../constants';

import type {SortablePosition} from '@pb/kit-component-native-sortable';

type Params = {|
    columnIndex: number,
    position: SortablePosition,
    colorLine?: string,
    tableId?: string,
|};

export const createStyleVerticalLine = (params: Params): HTMLStyleElement => {
    const {
        colorLine = colors.secondaryColors.orange,
        columnIndex,
        position,
        tableId = '',
    } = params;

    const style = document.createElement('style');
    const id = tableId ? `#${tableId}` : '';

    if (columnIndex === 0) {
        style.textContent = `${id} .${tableRowName}_fixed .${tableCellName}:last-child::before {
            background-color: ${colorLine};
        }`;
    } else if (position === SORTABLE_POSITION.BEFORE) {
        const index = columnIndex - 1;

        style.textContent = `
            ${id} .${tableRowName}:not([class*=fixed]) .${tableCellName}-${index},
            ${id} .${headerCellName}.${tableCellName}-${index} {
                border-right-color: ${colorLine};
            }`;
    } else {
        style.textContent = `
            ${id} .${tableRowName}:not([class*=fixed]) .${tableCellName}-${columnIndex},
            ${id} .${headerCellName}.${tableCellName}-${columnIndex} {
                border-right-color: ${colorLine};
            }`;
    }

    return style;
};

